module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp12_3009.0464f307.png";